import { motion
} from "framer-motion";


export const ScrollReveal = ({ children, className = "", delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 30
}}
    whileInView={{ opacity: 1, y: 0
}}
    viewport={{ once: true, margin: "-50px"
}}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1]
}}
    className={className}
  >
    {children}
  </motion.div>
);
